<template>
    <div class="container py-6">
        <LoadItem class="w-full h-32 rounded-md" />

        <div class="flex flex-col sm:flex-row gap-12 mt-9">
            <div class="w-full max-sm:hidden sm:max-w-[260px]">
                <!-- <FilterCard /> -->
                <div class="shadow-xl flex flex-col gap-3 px-4 py-6 rounded-md sticky top-20">
                    <div class="flex flex-row items-center gap-3">
                        <LoadContainer class="h-8" />
                        -
                        <LoadContainer class="h-8" />
                    </div>

                    <div class="font-medium text-sm group text-slate-600">
                        <LoadItemText class="h-8">
                            Loading Category
                        </LoadItemText>

                        <LoadContainer class="h-32" />
                    </div>
                    <div class="font-medium text-sm group text-slate-600">
                        <LoadItemText class="h-8">
                            Loading Series
                        </LoadItemText>

                        <LoadContainer class="h-32" />
                    </div>
                    <div class="font-medium text-sm group text-slate-600">
                        <LoadItemText class="h-8">
                            Loading Character
                        </LoadItemText>

                        <LoadContainer class="h-32" />
                    </div>
                </div>
            </div>

            <div class="grow w-full">
                <div class="w-full flex flex-row flex-wrap justify-between items-center">
                    <LoadItemText class="h-8 text-2xl font-bold">
                        Loading Product
                    </LoadItemText>
                    <LoadItem class="w-[150px] h-10 rounded-full" />
                </div>
                <div class="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 mt-3">
                    <LoadProduct v-for="(item, index) in 5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import LoadItemText from "@/Components/Skeleton/LoadItemText.vue";
import LoadContainer from "@/Components/Skeleton/LoadContainer.vue";
import LoadItem from "@/Components/Skeleton/LoadItem.vue";
import LoadProduct from "@/Components/Skeleton/LoadProduct.vue";
</script>